import React from "react";
import { CardContainer, StyledCardLink, ThumbnailImg, VideoTitle } from "../components";

const GameCard = ({ game }) => {
  return (
    <StyledCardLink to={game.id}>
      <CardContainer>
        <ThumbnailImg img={game.img} />
        <VideoTitle>{game.title}</VideoTitle>
      </CardContainer>
    </StyledCardLink>
  );
};

export default GameCard;
